/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { withDefault } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";
import {
  IWithinRangeIntegerTag,
  WithinRangeInteger
} from "@pagopa/ts-commons/lib/numbers";
import { NonNegativeInteger } from "@pagopa/ts-commons/lib/numbers";

// required attributes
const CreditorInstitutionStationR = t.interface({
  enabled: withDefault(t.boolean, true),

  station_code: t.string,

  version: t.union([
    WithinRangeInteger<1, 2, IWithinRangeIntegerTag<1, 2>>(1, 2),
    t.literal(2)
  ])
});

// optional attributes
const CreditorInstitutionStationO = t.partial({
  aca: t.boolean,

  application_code: NonNegativeInteger,

  aux_digit: t.Integer,

  broadcast: t.boolean,

  broker_description: t.string,

  is_connection_sync: t.boolean,

  mod4: t.boolean,

  segregation_code: NonNegativeInteger,

  spontaneous_payment: t.boolean,

  stand_in: t.boolean
});

export const CreditorInstitutionStation = t.intersection(
  [CreditorInstitutionStationR, CreditorInstitutionStationO],
  "CreditorInstitutionStation"
);

export type CreditorInstitutionStation = t.TypeOf<
  typeof CreditorInstitutionStation
>;
